/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as PublicRouteImport } from './routes/_public/route'
import { Route as AuthorizedRouteImport } from './routes/_authorized/route'
import { Route as IndexImport } from './routes/index'
import { Route as AuthorizedOnboardingImport } from './routes/_authorized/onboarding'
import { Route as AuthorizedTeammatesRouteImport } from './routes/_authorized/teammates/route'
import { Route as AuthorizedSubscriptionRouteImport } from './routes/_authorized/subscription/route'
import { Route as AuthorizedMonthlyConsentsRouteImport } from './routes/_authorized/monthly-consents/route'
import { Route as AuthorizedConsentSolutionsRouteImport } from './routes/_authorized/consent-solutions/route'
import { Route as PublicRecoveryEmailIndexImport } from './routes/_public/recovery-email/index'
import { Route as PublicLoginIndexImport } from './routes/_public/login/index'
import { Route as AuthorizedTeammatesIndexImport } from './routes/_authorized/teammates/index'
import { Route as AuthorizedSubscriptionIndexImport } from './routes/_authorized/subscription/index'
import { Route as AuthorizedMonthlyConsentsIndexImport } from './routes/_authorized/monthly-consents/index'
import { Route as AuthorizedFreePlanIndexImport } from './routes/_authorized/free-plan/index'
import { Route as AuthorizedConsentSolutionsIndexImport } from './routes/_authorized/consent-solutions/index'
import { Route as AuthorizedComplianceDashboardIndexImport } from './routes/_authorized/compliance-dashboard/index'
import { Route as AuthorizedConsentSolutionsCreateImport } from './routes/_authorized/consent-solutions/create'
import { Route as AuthorizedConsentSolutionsCsIdRouteImport } from './routes/_authorized/consent-solutions/$csId/route'
import { Route as AuthorizedTeammatesCreateIndexImport } from './routes/_authorized/teammates/create/index'
import { Route as AuthorizedSubscriptionSuccessIndexImport } from './routes/_authorized/subscription_.success/index'
import { Route as AuthorizedSubscriptionOverviewIndexImport } from './routes/_authorized/subscription/overview/index'
import { Route as AuthorizedSubscriptionBillingIndexImport } from './routes/_authorized/subscription/billing/index'
import { Route as AuthorizedConsentSolutionsCsIdIndexImport } from './routes/_authorized/consent-solutions/$csId/index'
import { Route as AuthorizedConsentSolutionsCsIdPopupRouteImport } from './routes/_authorized/consent-solutions/$csId/popup/route'
import { Route as AuthorizedConsentSolutionsCsIdCookieManagementRouteImport } from './routes/_authorized/consent-solutions/$csId/cookie-management/route'
import { Route as PublicNotificationsUnsubscribeFailureIndexImport } from './routes/_public/notifications/unsubscribe/failure/index'
import { Route as PublicNewpasswordPasswordTokenCsrfTokenIndexImport } from './routes/_public/newpassword/$passwordToken/$csrfToken/index'
import { Route as AuthorizedTeammatesTeammateIdEditIndexImport } from './routes/_authorized/teammates/$teammateId/edit/index'
import { Route as AuthorizedConsentSolutionsCsIdSettingsIndexImport } from './routes/_authorized/consent-solutions/$csId/settings/index'
import { Route as AuthorizedConsentSolutionsCsIdPopupIndexImport } from './routes/_authorized/consent-solutions/$csId/popup/index'
import { Route as AuthorizedConsentSolutionsCsIdInstallationIndexImport } from './routes/_authorized/consent-solutions/$csId/installation/index'
import { Route as AuthorizedConsentSolutionsCsIdDomainsIndexImport } from './routes/_authorized/consent-solutions/$csId/domains/index'
import { Route as AuthorizedConsentSolutionsCsIdCopyAndTranslationsIndexImport } from './routes/_authorized/consent-solutions/$csId/copy-and-translations/index'
import { Route as AuthorizedConsentSolutionsCsIdCookieManagementIndexImport } from './routes/_authorized/consent-solutions/$csId/cookie-management/index'
import { Route as PublicNotificationsUnsubscribeSuccessPayloadIndexImport } from './routes/_public/notifications/unsubscribe/success/$payload/index'
import { Route as AuthorizedConsentSolutionsCsIdPopupTemplateGalleryIndexImport } from './routes/_authorized/consent-solutions/$csId/popup/template-gallery/index'
import { Route as AuthorizedConsentSolutionsCsIdPopupMyTemplatesIndexImport } from './routes/_authorized/consent-solutions/$csId/popup/my-templates/index'
import { Route as AuthorizedConsentSolutionsCsIdPopupAccountTemplatesIndexImport } from './routes/_authorized/consent-solutions/$csId/popup/account-templates/index'
import { Route as AuthorizedConsentSolutionsCsIdDomainsCreateIndexImport } from './routes/_authorized/consent-solutions/$csId/domains/create/index'
import { Route as AuthorizedConsentSolutionsCsIdDomainsDomainIdIndexImport } from './routes/_authorized/consent-solutions/$csId/domains/$domainId/index'
import { Route as AuthorizedConsentSolutionsCsIdCookieManagementCreateIndexImport } from './routes/_authorized/consent-solutions/$csId/cookie-management/create/index'
import { Route as AuthorizedConsentSolutionsCsIdCookieManagementCookieIdIndexImport } from './routes/_authorized/consent-solutions/$csId/cookie-management/$cookieId/index'
import { Route as AuthorizedConsentSolutionsCsIdPopupEditTemplateTemplateIdTemplateActionIndexImport } from './routes/_authorized/consent-solutions/$csId/popup_.edit-template/$templateId/$templateAction/index'

// Create/Update Routes

const PublicRouteRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRoute,
} as any)

const AuthorizedRouteRoute = AuthorizedRouteImport.update({
  id: '/_authorized',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const AuthorizedOnboardingRoute = AuthorizedOnboardingImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => AuthorizedRouteRoute,
} as any)

const AuthorizedTeammatesRouteRoute = AuthorizedTeammatesRouteImport.update({
  id: '/teammates',
  path: '/teammates',
  getParentRoute: () => AuthorizedRouteRoute,
} as any)

const AuthorizedSubscriptionRouteRoute =
  AuthorizedSubscriptionRouteImport.update({
    id: '/subscription',
    path: '/subscription',
    getParentRoute: () => AuthorizedRouteRoute,
  } as any)

const AuthorizedMonthlyConsentsRouteRoute =
  AuthorizedMonthlyConsentsRouteImport.update({
    id: '/monthly-consents',
    path: '/monthly-consents',
    getParentRoute: () => AuthorizedRouteRoute,
  } as any)

const AuthorizedConsentSolutionsRouteRoute =
  AuthorizedConsentSolutionsRouteImport.update({
    id: '/consent-solutions',
    path: '/consent-solutions',
    getParentRoute: () => AuthorizedRouteRoute,
  } as any)

const PublicRecoveryEmailIndexRoute = PublicRecoveryEmailIndexImport.update({
  id: '/recovery-email/',
  path: '/recovery-email/',
  getParentRoute: () => PublicRouteRoute,
} as any)

const PublicLoginIndexRoute = PublicLoginIndexImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => PublicRouteRoute,
} as any)

const AuthorizedTeammatesIndexRoute = AuthorizedTeammatesIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthorizedTeammatesRouteRoute,
} as any)

const AuthorizedSubscriptionIndexRoute =
  AuthorizedSubscriptionIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthorizedSubscriptionRouteRoute,
  } as any)

const AuthorizedMonthlyConsentsIndexRoute =
  AuthorizedMonthlyConsentsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthorizedMonthlyConsentsRouteRoute,
  } as any)

const AuthorizedFreePlanIndexRoute = AuthorizedFreePlanIndexImport.update({
  id: '/free-plan/',
  path: '/free-plan/',
  getParentRoute: () => AuthorizedRouteRoute,
} as any)

const AuthorizedConsentSolutionsIndexRoute =
  AuthorizedConsentSolutionsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthorizedConsentSolutionsRouteRoute,
  } as any)

const AuthorizedComplianceDashboardIndexRoute =
  AuthorizedComplianceDashboardIndexImport.update({
    id: '/compliance-dashboard/',
    path: '/compliance-dashboard/',
    getParentRoute: () => AuthorizedRouteRoute,
  } as any)

const AuthorizedConsentSolutionsCreateRoute =
  AuthorizedConsentSolutionsCreateImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthorizedConsentSolutionsRouteRoute,
  } as any)

const AuthorizedConsentSolutionsCsIdRouteRoute =
  AuthorizedConsentSolutionsCsIdRouteImport.update({
    id: '/$csId',
    path: '/$csId',
    getParentRoute: () => AuthorizedConsentSolutionsRouteRoute,
  } as any)

const AuthorizedTeammatesCreateIndexRoute =
  AuthorizedTeammatesCreateIndexImport.update({
    id: '/create/',
    path: '/create/',
    getParentRoute: () => AuthorizedTeammatesRouteRoute,
  } as any)

const AuthorizedSubscriptionSuccessIndexRoute =
  AuthorizedSubscriptionSuccessIndexImport.update({
    id: '/subscription_/success/',
    path: '/subscription/success/',
    getParentRoute: () => AuthorizedRouteRoute,
  } as any)

const AuthorizedSubscriptionOverviewIndexRoute =
  AuthorizedSubscriptionOverviewIndexImport.update({
    id: '/overview/',
    path: '/overview/',
    getParentRoute: () => AuthorizedSubscriptionRouteRoute,
  } as any)

const AuthorizedSubscriptionBillingIndexRoute =
  AuthorizedSubscriptionBillingIndexImport.update({
    id: '/billing/',
    path: '/billing/',
    getParentRoute: () => AuthorizedSubscriptionRouteRoute,
  } as any)

const AuthorizedConsentSolutionsCsIdIndexRoute =
  AuthorizedConsentSolutionsCsIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthorizedConsentSolutionsCsIdRouteRoute,
  } as any)

const AuthorizedConsentSolutionsCsIdPopupRouteRoute =
  AuthorizedConsentSolutionsCsIdPopupRouteImport.update({
    id: '/popup',
    path: '/popup',
    getParentRoute: () => AuthorizedConsentSolutionsCsIdRouteRoute,
  } as any)

const AuthorizedConsentSolutionsCsIdCookieManagementRouteRoute =
  AuthorizedConsentSolutionsCsIdCookieManagementRouteImport.update({
    id: '/cookie-management',
    path: '/cookie-management',
    getParentRoute: () => AuthorizedConsentSolutionsCsIdRouteRoute,
  } as any)

const PublicNotificationsUnsubscribeFailureIndexRoute =
  PublicNotificationsUnsubscribeFailureIndexImport.update({
    id: '/notifications/unsubscribe/failure/',
    path: '/notifications/unsubscribe/failure/',
    getParentRoute: () => PublicRouteRoute,
  } as any)

const PublicNewpasswordPasswordTokenCsrfTokenIndexRoute =
  PublicNewpasswordPasswordTokenCsrfTokenIndexImport.update({
    id: '/newpassword/$passwordToken/$csrfToken/',
    path: '/newpassword/$passwordToken/$csrfToken/',
    getParentRoute: () => PublicRouteRoute,
  } as any)

const AuthorizedTeammatesTeammateIdEditIndexRoute =
  AuthorizedTeammatesTeammateIdEditIndexImport.update({
    id: '/$teammateId/edit/',
    path: '/$teammateId/edit/',
    getParentRoute: () => AuthorizedTeammatesRouteRoute,
  } as any)

const AuthorizedConsentSolutionsCsIdSettingsIndexRoute =
  AuthorizedConsentSolutionsCsIdSettingsIndexImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => AuthorizedConsentSolutionsCsIdRouteRoute,
  } as any)

const AuthorizedConsentSolutionsCsIdPopupIndexRoute =
  AuthorizedConsentSolutionsCsIdPopupIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthorizedConsentSolutionsCsIdPopupRouteRoute,
  } as any)

const AuthorizedConsentSolutionsCsIdInstallationIndexRoute =
  AuthorizedConsentSolutionsCsIdInstallationIndexImport.update({
    id: '/installation/',
    path: '/installation/',
    getParentRoute: () => AuthorizedConsentSolutionsCsIdRouteRoute,
  } as any)

const AuthorizedConsentSolutionsCsIdDomainsIndexRoute =
  AuthorizedConsentSolutionsCsIdDomainsIndexImport.update({
    id: '/domains/',
    path: '/domains/',
    getParentRoute: () => AuthorizedConsentSolutionsCsIdRouteRoute,
  } as any)

const AuthorizedConsentSolutionsCsIdCopyAndTranslationsIndexRoute =
  AuthorizedConsentSolutionsCsIdCopyAndTranslationsIndexImport.update({
    id: '/copy-and-translations/',
    path: '/copy-and-translations/',
    getParentRoute: () => AuthorizedConsentSolutionsCsIdRouteRoute,
  } as any)

const AuthorizedConsentSolutionsCsIdCookieManagementIndexRoute =
  AuthorizedConsentSolutionsCsIdCookieManagementIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthorizedConsentSolutionsCsIdCookieManagementRouteRoute,
  } as any)

const PublicNotificationsUnsubscribeSuccessPayloadIndexRoute =
  PublicNotificationsUnsubscribeSuccessPayloadIndexImport.update({
    id: '/notifications/unsubscribe/success/$payload/',
    path: '/notifications/unsubscribe/success/$payload/',
    getParentRoute: () => PublicRouteRoute,
  } as any)

const AuthorizedConsentSolutionsCsIdPopupTemplateGalleryIndexRoute =
  AuthorizedConsentSolutionsCsIdPopupTemplateGalleryIndexImport.update({
    id: '/template-gallery/',
    path: '/template-gallery/',
    getParentRoute: () => AuthorizedConsentSolutionsCsIdPopupRouteRoute,
  } as any)

const AuthorizedConsentSolutionsCsIdPopupMyTemplatesIndexRoute =
  AuthorizedConsentSolutionsCsIdPopupMyTemplatesIndexImport.update({
    id: '/my-templates/',
    path: '/my-templates/',
    getParentRoute: () => AuthorizedConsentSolutionsCsIdPopupRouteRoute,
  } as any)

const AuthorizedConsentSolutionsCsIdPopupAccountTemplatesIndexRoute =
  AuthorizedConsentSolutionsCsIdPopupAccountTemplatesIndexImport.update({
    id: '/account-templates/',
    path: '/account-templates/',
    getParentRoute: () => AuthorizedConsentSolutionsCsIdPopupRouteRoute,
  } as any)

const AuthorizedConsentSolutionsCsIdDomainsCreateIndexRoute =
  AuthorizedConsentSolutionsCsIdDomainsCreateIndexImport.update({
    id: '/domains/create/',
    path: '/domains/create/',
    getParentRoute: () => AuthorizedConsentSolutionsCsIdRouteRoute,
  } as any)

const AuthorizedConsentSolutionsCsIdDomainsDomainIdIndexRoute =
  AuthorizedConsentSolutionsCsIdDomainsDomainIdIndexImport.update({
    id: '/domains/$domainId/',
    path: '/domains/$domainId/',
    getParentRoute: () => AuthorizedConsentSolutionsCsIdRouteRoute,
  } as any)

const AuthorizedConsentSolutionsCsIdCookieManagementCreateIndexRoute =
  AuthorizedConsentSolutionsCsIdCookieManagementCreateIndexImport.update({
    id: '/create/',
    path: '/create/',
    getParentRoute: () =>
      AuthorizedConsentSolutionsCsIdCookieManagementRouteRoute,
  } as any)

const AuthorizedConsentSolutionsCsIdCookieManagementCookieIdIndexRoute =
  AuthorizedConsentSolutionsCsIdCookieManagementCookieIdIndexImport.update({
    id: '/$cookieId/',
    path: '/$cookieId/',
    getParentRoute: () =>
      AuthorizedConsentSolutionsCsIdCookieManagementRouteRoute,
  } as any)

const AuthorizedConsentSolutionsCsIdPopupEditTemplateTemplateIdTemplateActionIndexRoute =
  AuthorizedConsentSolutionsCsIdPopupEditTemplateTemplateIdTemplateActionIndexImport.update(
    {
      id: '/popup_/edit-template/$templateId/$templateAction/',
      path: '/popup/edit-template/$templateId/$templateAction/',
      getParentRoute: () => AuthorizedConsentSolutionsCsIdRouteRoute,
    } as any,
  )

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_authorized': {
      id: '/_authorized'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthorizedRouteImport
      parentRoute: typeof rootRoute
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRoute
    }
    '/_authorized/consent-solutions': {
      id: '/_authorized/consent-solutions'
      path: '/consent-solutions'
      fullPath: '/consent-solutions'
      preLoaderRoute: typeof AuthorizedConsentSolutionsRouteImport
      parentRoute: typeof AuthorizedRouteImport
    }
    '/_authorized/monthly-consents': {
      id: '/_authorized/monthly-consents'
      path: '/monthly-consents'
      fullPath: '/monthly-consents'
      preLoaderRoute: typeof AuthorizedMonthlyConsentsRouteImport
      parentRoute: typeof AuthorizedRouteImport
    }
    '/_authorized/subscription': {
      id: '/_authorized/subscription'
      path: '/subscription'
      fullPath: '/subscription'
      preLoaderRoute: typeof AuthorizedSubscriptionRouteImport
      parentRoute: typeof AuthorizedRouteImport
    }
    '/_authorized/teammates': {
      id: '/_authorized/teammates'
      path: '/teammates'
      fullPath: '/teammates'
      preLoaderRoute: typeof AuthorizedTeammatesRouteImport
      parentRoute: typeof AuthorizedRouteImport
    }
    '/_authorized/onboarding': {
      id: '/_authorized/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof AuthorizedOnboardingImport
      parentRoute: typeof AuthorizedRouteImport
    }
    '/_authorized/consent-solutions/$csId': {
      id: '/_authorized/consent-solutions/$csId'
      path: '/$csId'
      fullPath: '/consent-solutions/$csId'
      preLoaderRoute: typeof AuthorizedConsentSolutionsCsIdRouteImport
      parentRoute: typeof AuthorizedConsentSolutionsRouteImport
    }
    '/_authorized/consent-solutions/create': {
      id: '/_authorized/consent-solutions/create'
      path: '/create'
      fullPath: '/consent-solutions/create'
      preLoaderRoute: typeof AuthorizedConsentSolutionsCreateImport
      parentRoute: typeof AuthorizedConsentSolutionsRouteImport
    }
    '/_authorized/compliance-dashboard/': {
      id: '/_authorized/compliance-dashboard/'
      path: '/compliance-dashboard'
      fullPath: '/compliance-dashboard'
      preLoaderRoute: typeof AuthorizedComplianceDashboardIndexImport
      parentRoute: typeof AuthorizedRouteImport
    }
    '/_authorized/consent-solutions/': {
      id: '/_authorized/consent-solutions/'
      path: '/'
      fullPath: '/consent-solutions/'
      preLoaderRoute: typeof AuthorizedConsentSolutionsIndexImport
      parentRoute: typeof AuthorizedConsentSolutionsRouteImport
    }
    '/_authorized/free-plan/': {
      id: '/_authorized/free-plan/'
      path: '/free-plan'
      fullPath: '/free-plan'
      preLoaderRoute: typeof AuthorizedFreePlanIndexImport
      parentRoute: typeof AuthorizedRouteImport
    }
    '/_authorized/monthly-consents/': {
      id: '/_authorized/monthly-consents/'
      path: '/'
      fullPath: '/monthly-consents/'
      preLoaderRoute: typeof AuthorizedMonthlyConsentsIndexImport
      parentRoute: typeof AuthorizedMonthlyConsentsRouteImport
    }
    '/_authorized/subscription/': {
      id: '/_authorized/subscription/'
      path: '/'
      fullPath: '/subscription/'
      preLoaderRoute: typeof AuthorizedSubscriptionIndexImport
      parentRoute: typeof AuthorizedSubscriptionRouteImport
    }
    '/_authorized/teammates/': {
      id: '/_authorized/teammates/'
      path: '/'
      fullPath: '/teammates/'
      preLoaderRoute: typeof AuthorizedTeammatesIndexImport
      parentRoute: typeof AuthorizedTeammatesRouteImport
    }
    '/_public/login/': {
      id: '/_public/login/'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof PublicLoginIndexImport
      parentRoute: typeof PublicRouteImport
    }
    '/_public/recovery-email/': {
      id: '/_public/recovery-email/'
      path: '/recovery-email'
      fullPath: '/recovery-email'
      preLoaderRoute: typeof PublicRecoveryEmailIndexImport
      parentRoute: typeof PublicRouteImport
    }
    '/_authorized/consent-solutions/$csId/cookie-management': {
      id: '/_authorized/consent-solutions/$csId/cookie-management'
      path: '/cookie-management'
      fullPath: '/consent-solutions/$csId/cookie-management'
      preLoaderRoute: typeof AuthorizedConsentSolutionsCsIdCookieManagementRouteImport
      parentRoute: typeof AuthorizedConsentSolutionsCsIdRouteImport
    }
    '/_authorized/consent-solutions/$csId/popup': {
      id: '/_authorized/consent-solutions/$csId/popup'
      path: '/popup'
      fullPath: '/consent-solutions/$csId/popup'
      preLoaderRoute: typeof AuthorizedConsentSolutionsCsIdPopupRouteImport
      parentRoute: typeof AuthorizedConsentSolutionsCsIdRouteImport
    }
    '/_authorized/consent-solutions/$csId/': {
      id: '/_authorized/consent-solutions/$csId/'
      path: '/'
      fullPath: '/consent-solutions/$csId/'
      preLoaderRoute: typeof AuthorizedConsentSolutionsCsIdIndexImport
      parentRoute: typeof AuthorizedConsentSolutionsCsIdRouteImport
    }
    '/_authorized/subscription/billing/': {
      id: '/_authorized/subscription/billing/'
      path: '/billing'
      fullPath: '/subscription/billing'
      preLoaderRoute: typeof AuthorizedSubscriptionBillingIndexImport
      parentRoute: typeof AuthorizedSubscriptionRouteImport
    }
    '/_authorized/subscription/overview/': {
      id: '/_authorized/subscription/overview/'
      path: '/overview'
      fullPath: '/subscription/overview'
      preLoaderRoute: typeof AuthorizedSubscriptionOverviewIndexImport
      parentRoute: typeof AuthorizedSubscriptionRouteImport
    }
    '/_authorized/subscription_/success/': {
      id: '/_authorized/subscription_/success/'
      path: '/subscription/success'
      fullPath: '/subscription/success'
      preLoaderRoute: typeof AuthorizedSubscriptionSuccessIndexImport
      parentRoute: typeof AuthorizedRouteImport
    }
    '/_authorized/teammates/create/': {
      id: '/_authorized/teammates/create/'
      path: '/create'
      fullPath: '/teammates/create'
      preLoaderRoute: typeof AuthorizedTeammatesCreateIndexImport
      parentRoute: typeof AuthorizedTeammatesRouteImport
    }
    '/_authorized/consent-solutions/$csId/cookie-management/': {
      id: '/_authorized/consent-solutions/$csId/cookie-management/'
      path: '/'
      fullPath: '/consent-solutions/$csId/cookie-management/'
      preLoaderRoute: typeof AuthorizedConsentSolutionsCsIdCookieManagementIndexImport
      parentRoute: typeof AuthorizedConsentSolutionsCsIdCookieManagementRouteImport
    }
    '/_authorized/consent-solutions/$csId/copy-and-translations/': {
      id: '/_authorized/consent-solutions/$csId/copy-and-translations/'
      path: '/copy-and-translations'
      fullPath: '/consent-solutions/$csId/copy-and-translations'
      preLoaderRoute: typeof AuthorizedConsentSolutionsCsIdCopyAndTranslationsIndexImport
      parentRoute: typeof AuthorizedConsentSolutionsCsIdRouteImport
    }
    '/_authorized/consent-solutions/$csId/domains/': {
      id: '/_authorized/consent-solutions/$csId/domains/'
      path: '/domains'
      fullPath: '/consent-solutions/$csId/domains'
      preLoaderRoute: typeof AuthorizedConsentSolutionsCsIdDomainsIndexImport
      parentRoute: typeof AuthorizedConsentSolutionsCsIdRouteImport
    }
    '/_authorized/consent-solutions/$csId/installation/': {
      id: '/_authorized/consent-solutions/$csId/installation/'
      path: '/installation'
      fullPath: '/consent-solutions/$csId/installation'
      preLoaderRoute: typeof AuthorizedConsentSolutionsCsIdInstallationIndexImport
      parentRoute: typeof AuthorizedConsentSolutionsCsIdRouteImport
    }
    '/_authorized/consent-solutions/$csId/popup/': {
      id: '/_authorized/consent-solutions/$csId/popup/'
      path: '/'
      fullPath: '/consent-solutions/$csId/popup/'
      preLoaderRoute: typeof AuthorizedConsentSolutionsCsIdPopupIndexImport
      parentRoute: typeof AuthorizedConsentSolutionsCsIdPopupRouteImport
    }
    '/_authorized/consent-solutions/$csId/settings/': {
      id: '/_authorized/consent-solutions/$csId/settings/'
      path: '/settings'
      fullPath: '/consent-solutions/$csId/settings'
      preLoaderRoute: typeof AuthorizedConsentSolutionsCsIdSettingsIndexImport
      parentRoute: typeof AuthorizedConsentSolutionsCsIdRouteImport
    }
    '/_authorized/teammates/$teammateId/edit/': {
      id: '/_authorized/teammates/$teammateId/edit/'
      path: '/$teammateId/edit'
      fullPath: '/teammates/$teammateId/edit'
      preLoaderRoute: typeof AuthorizedTeammatesTeammateIdEditIndexImport
      parentRoute: typeof AuthorizedTeammatesRouteImport
    }
    '/_public/newpassword/$passwordToken/$csrfToken/': {
      id: '/_public/newpassword/$passwordToken/$csrfToken/'
      path: '/newpassword/$passwordToken/$csrfToken'
      fullPath: '/newpassword/$passwordToken/$csrfToken'
      preLoaderRoute: typeof PublicNewpasswordPasswordTokenCsrfTokenIndexImport
      parentRoute: typeof PublicRouteImport
    }
    '/_public/notifications/unsubscribe/failure/': {
      id: '/_public/notifications/unsubscribe/failure/'
      path: '/notifications/unsubscribe/failure'
      fullPath: '/notifications/unsubscribe/failure'
      preLoaderRoute: typeof PublicNotificationsUnsubscribeFailureIndexImport
      parentRoute: typeof PublicRouteImport
    }
    '/_authorized/consent-solutions/$csId/cookie-management/$cookieId/': {
      id: '/_authorized/consent-solutions/$csId/cookie-management/$cookieId/'
      path: '/$cookieId'
      fullPath: '/consent-solutions/$csId/cookie-management/$cookieId'
      preLoaderRoute: typeof AuthorizedConsentSolutionsCsIdCookieManagementCookieIdIndexImport
      parentRoute: typeof AuthorizedConsentSolutionsCsIdCookieManagementRouteImport
    }
    '/_authorized/consent-solutions/$csId/cookie-management/create/': {
      id: '/_authorized/consent-solutions/$csId/cookie-management/create/'
      path: '/create'
      fullPath: '/consent-solutions/$csId/cookie-management/create'
      preLoaderRoute: typeof AuthorizedConsentSolutionsCsIdCookieManagementCreateIndexImport
      parentRoute: typeof AuthorizedConsentSolutionsCsIdCookieManagementRouteImport
    }
    '/_authorized/consent-solutions/$csId/domains/$domainId/': {
      id: '/_authorized/consent-solutions/$csId/domains/$domainId/'
      path: '/domains/$domainId'
      fullPath: '/consent-solutions/$csId/domains/$domainId'
      preLoaderRoute: typeof AuthorizedConsentSolutionsCsIdDomainsDomainIdIndexImport
      parentRoute: typeof AuthorizedConsentSolutionsCsIdRouteImport
    }
    '/_authorized/consent-solutions/$csId/domains/create/': {
      id: '/_authorized/consent-solutions/$csId/domains/create/'
      path: '/domains/create'
      fullPath: '/consent-solutions/$csId/domains/create'
      preLoaderRoute: typeof AuthorizedConsentSolutionsCsIdDomainsCreateIndexImport
      parentRoute: typeof AuthorizedConsentSolutionsCsIdRouteImport
    }
    '/_authorized/consent-solutions/$csId/popup/account-templates/': {
      id: '/_authorized/consent-solutions/$csId/popup/account-templates/'
      path: '/account-templates'
      fullPath: '/consent-solutions/$csId/popup/account-templates'
      preLoaderRoute: typeof AuthorizedConsentSolutionsCsIdPopupAccountTemplatesIndexImport
      parentRoute: typeof AuthorizedConsentSolutionsCsIdPopupRouteImport
    }
    '/_authorized/consent-solutions/$csId/popup/my-templates/': {
      id: '/_authorized/consent-solutions/$csId/popup/my-templates/'
      path: '/my-templates'
      fullPath: '/consent-solutions/$csId/popup/my-templates'
      preLoaderRoute: typeof AuthorizedConsentSolutionsCsIdPopupMyTemplatesIndexImport
      parentRoute: typeof AuthorizedConsentSolutionsCsIdPopupRouteImport
    }
    '/_authorized/consent-solutions/$csId/popup/template-gallery/': {
      id: '/_authorized/consent-solutions/$csId/popup/template-gallery/'
      path: '/template-gallery'
      fullPath: '/consent-solutions/$csId/popup/template-gallery'
      preLoaderRoute: typeof AuthorizedConsentSolutionsCsIdPopupTemplateGalleryIndexImport
      parentRoute: typeof AuthorizedConsentSolutionsCsIdPopupRouteImport
    }
    '/_public/notifications/unsubscribe/success/$payload/': {
      id: '/_public/notifications/unsubscribe/success/$payload/'
      path: '/notifications/unsubscribe/success/$payload'
      fullPath: '/notifications/unsubscribe/success/$payload'
      preLoaderRoute: typeof PublicNotificationsUnsubscribeSuccessPayloadIndexImport
      parentRoute: typeof PublicRouteImport
    }
    '/_authorized/consent-solutions/$csId/popup_/edit-template/$templateId/$templateAction/': {
      id: '/_authorized/consent-solutions/$csId/popup_/edit-template/$templateId/$templateAction/'
      path: '/popup/edit-template/$templateId/$templateAction'
      fullPath: '/consent-solutions/$csId/popup/edit-template/$templateId/$templateAction'
      preLoaderRoute: typeof AuthorizedConsentSolutionsCsIdPopupEditTemplateTemplateIdTemplateActionIndexImport
      parentRoute: typeof AuthorizedConsentSolutionsCsIdRouteImport
    }
  }
}

// Create and export the route tree

interface AuthorizedConsentSolutionsCsIdCookieManagementRouteRouteChildren {
  AuthorizedConsentSolutionsCsIdCookieManagementIndexRoute: typeof AuthorizedConsentSolutionsCsIdCookieManagementIndexRoute
  AuthorizedConsentSolutionsCsIdCookieManagementCookieIdIndexRoute: typeof AuthorizedConsentSolutionsCsIdCookieManagementCookieIdIndexRoute
  AuthorizedConsentSolutionsCsIdCookieManagementCreateIndexRoute: typeof AuthorizedConsentSolutionsCsIdCookieManagementCreateIndexRoute
}

const AuthorizedConsentSolutionsCsIdCookieManagementRouteRouteChildren: AuthorizedConsentSolutionsCsIdCookieManagementRouteRouteChildren =
  {
    AuthorizedConsentSolutionsCsIdCookieManagementIndexRoute:
      AuthorizedConsentSolutionsCsIdCookieManagementIndexRoute,
    AuthorizedConsentSolutionsCsIdCookieManagementCookieIdIndexRoute:
      AuthorizedConsentSolutionsCsIdCookieManagementCookieIdIndexRoute,
    AuthorizedConsentSolutionsCsIdCookieManagementCreateIndexRoute:
      AuthorizedConsentSolutionsCsIdCookieManagementCreateIndexRoute,
  }

const AuthorizedConsentSolutionsCsIdCookieManagementRouteRouteWithChildren =
  AuthorizedConsentSolutionsCsIdCookieManagementRouteRoute._addFileChildren(
    AuthorizedConsentSolutionsCsIdCookieManagementRouteRouteChildren,
  )

interface AuthorizedConsentSolutionsCsIdPopupRouteRouteChildren {
  AuthorizedConsentSolutionsCsIdPopupIndexRoute: typeof AuthorizedConsentSolutionsCsIdPopupIndexRoute
  AuthorizedConsentSolutionsCsIdPopupAccountTemplatesIndexRoute: typeof AuthorizedConsentSolutionsCsIdPopupAccountTemplatesIndexRoute
  AuthorizedConsentSolutionsCsIdPopupMyTemplatesIndexRoute: typeof AuthorizedConsentSolutionsCsIdPopupMyTemplatesIndexRoute
  AuthorizedConsentSolutionsCsIdPopupTemplateGalleryIndexRoute: typeof AuthorizedConsentSolutionsCsIdPopupTemplateGalleryIndexRoute
}

const AuthorizedConsentSolutionsCsIdPopupRouteRouteChildren: AuthorizedConsentSolutionsCsIdPopupRouteRouteChildren =
  {
    AuthorizedConsentSolutionsCsIdPopupIndexRoute:
      AuthorizedConsentSolutionsCsIdPopupIndexRoute,
    AuthorizedConsentSolutionsCsIdPopupAccountTemplatesIndexRoute:
      AuthorizedConsentSolutionsCsIdPopupAccountTemplatesIndexRoute,
    AuthorizedConsentSolutionsCsIdPopupMyTemplatesIndexRoute:
      AuthorizedConsentSolutionsCsIdPopupMyTemplatesIndexRoute,
    AuthorizedConsentSolutionsCsIdPopupTemplateGalleryIndexRoute:
      AuthorizedConsentSolutionsCsIdPopupTemplateGalleryIndexRoute,
  }

const AuthorizedConsentSolutionsCsIdPopupRouteRouteWithChildren =
  AuthorizedConsentSolutionsCsIdPopupRouteRoute._addFileChildren(
    AuthorizedConsentSolutionsCsIdPopupRouteRouteChildren,
  )

interface AuthorizedConsentSolutionsCsIdRouteRouteChildren {
  AuthorizedConsentSolutionsCsIdCookieManagementRouteRoute: typeof AuthorizedConsentSolutionsCsIdCookieManagementRouteRouteWithChildren
  AuthorizedConsentSolutionsCsIdPopupRouteRoute: typeof AuthorizedConsentSolutionsCsIdPopupRouteRouteWithChildren
  AuthorizedConsentSolutionsCsIdIndexRoute: typeof AuthorizedConsentSolutionsCsIdIndexRoute
  AuthorizedConsentSolutionsCsIdCopyAndTranslationsIndexRoute: typeof AuthorizedConsentSolutionsCsIdCopyAndTranslationsIndexRoute
  AuthorizedConsentSolutionsCsIdDomainsIndexRoute: typeof AuthorizedConsentSolutionsCsIdDomainsIndexRoute
  AuthorizedConsentSolutionsCsIdInstallationIndexRoute: typeof AuthorizedConsentSolutionsCsIdInstallationIndexRoute
  AuthorizedConsentSolutionsCsIdSettingsIndexRoute: typeof AuthorizedConsentSolutionsCsIdSettingsIndexRoute
  AuthorizedConsentSolutionsCsIdDomainsDomainIdIndexRoute: typeof AuthorizedConsentSolutionsCsIdDomainsDomainIdIndexRoute
  AuthorizedConsentSolutionsCsIdDomainsCreateIndexRoute: typeof AuthorizedConsentSolutionsCsIdDomainsCreateIndexRoute
  AuthorizedConsentSolutionsCsIdPopupEditTemplateTemplateIdTemplateActionIndexRoute: typeof AuthorizedConsentSolutionsCsIdPopupEditTemplateTemplateIdTemplateActionIndexRoute
}

const AuthorizedConsentSolutionsCsIdRouteRouteChildren: AuthorizedConsentSolutionsCsIdRouteRouteChildren =
  {
    AuthorizedConsentSolutionsCsIdCookieManagementRouteRoute:
      AuthorizedConsentSolutionsCsIdCookieManagementRouteRouteWithChildren,
    AuthorizedConsentSolutionsCsIdPopupRouteRoute:
      AuthorizedConsentSolutionsCsIdPopupRouteRouteWithChildren,
    AuthorizedConsentSolutionsCsIdIndexRoute:
      AuthorizedConsentSolutionsCsIdIndexRoute,
    AuthorizedConsentSolutionsCsIdCopyAndTranslationsIndexRoute:
      AuthorizedConsentSolutionsCsIdCopyAndTranslationsIndexRoute,
    AuthorizedConsentSolutionsCsIdDomainsIndexRoute:
      AuthorizedConsentSolutionsCsIdDomainsIndexRoute,
    AuthorizedConsentSolutionsCsIdInstallationIndexRoute:
      AuthorizedConsentSolutionsCsIdInstallationIndexRoute,
    AuthorizedConsentSolutionsCsIdSettingsIndexRoute:
      AuthorizedConsentSolutionsCsIdSettingsIndexRoute,
    AuthorizedConsentSolutionsCsIdDomainsDomainIdIndexRoute:
      AuthorizedConsentSolutionsCsIdDomainsDomainIdIndexRoute,
    AuthorizedConsentSolutionsCsIdDomainsCreateIndexRoute:
      AuthorizedConsentSolutionsCsIdDomainsCreateIndexRoute,
    AuthorizedConsentSolutionsCsIdPopupEditTemplateTemplateIdTemplateActionIndexRoute:
      AuthorizedConsentSolutionsCsIdPopupEditTemplateTemplateIdTemplateActionIndexRoute,
  }

const AuthorizedConsentSolutionsCsIdRouteRouteWithChildren =
  AuthorizedConsentSolutionsCsIdRouteRoute._addFileChildren(
    AuthorizedConsentSolutionsCsIdRouteRouteChildren,
  )

interface AuthorizedConsentSolutionsRouteRouteChildren {
  AuthorizedConsentSolutionsCsIdRouteRoute: typeof AuthorizedConsentSolutionsCsIdRouteRouteWithChildren
  AuthorizedConsentSolutionsCreateRoute: typeof AuthorizedConsentSolutionsCreateRoute
  AuthorizedConsentSolutionsIndexRoute: typeof AuthorizedConsentSolutionsIndexRoute
}

const AuthorizedConsentSolutionsRouteRouteChildren: AuthorizedConsentSolutionsRouteRouteChildren =
  {
    AuthorizedConsentSolutionsCsIdRouteRoute:
      AuthorizedConsentSolutionsCsIdRouteRouteWithChildren,
    AuthorizedConsentSolutionsCreateRoute:
      AuthorizedConsentSolutionsCreateRoute,
    AuthorizedConsentSolutionsIndexRoute: AuthorizedConsentSolutionsIndexRoute,
  }

const AuthorizedConsentSolutionsRouteRouteWithChildren =
  AuthorizedConsentSolutionsRouteRoute._addFileChildren(
    AuthorizedConsentSolutionsRouteRouteChildren,
  )

interface AuthorizedMonthlyConsentsRouteRouteChildren {
  AuthorizedMonthlyConsentsIndexRoute: typeof AuthorizedMonthlyConsentsIndexRoute
}

const AuthorizedMonthlyConsentsRouteRouteChildren: AuthorizedMonthlyConsentsRouteRouteChildren =
  {
    AuthorizedMonthlyConsentsIndexRoute: AuthorizedMonthlyConsentsIndexRoute,
  }

const AuthorizedMonthlyConsentsRouteRouteWithChildren =
  AuthorizedMonthlyConsentsRouteRoute._addFileChildren(
    AuthorizedMonthlyConsentsRouteRouteChildren,
  )

interface AuthorizedSubscriptionRouteRouteChildren {
  AuthorizedSubscriptionIndexRoute: typeof AuthorizedSubscriptionIndexRoute
  AuthorizedSubscriptionBillingIndexRoute: typeof AuthorizedSubscriptionBillingIndexRoute
  AuthorizedSubscriptionOverviewIndexRoute: typeof AuthorizedSubscriptionOverviewIndexRoute
}

const AuthorizedSubscriptionRouteRouteChildren: AuthorizedSubscriptionRouteRouteChildren =
  {
    AuthorizedSubscriptionIndexRoute: AuthorizedSubscriptionIndexRoute,
    AuthorizedSubscriptionBillingIndexRoute:
      AuthorizedSubscriptionBillingIndexRoute,
    AuthorizedSubscriptionOverviewIndexRoute:
      AuthorizedSubscriptionOverviewIndexRoute,
  }

const AuthorizedSubscriptionRouteRouteWithChildren =
  AuthorizedSubscriptionRouteRoute._addFileChildren(
    AuthorizedSubscriptionRouteRouteChildren,
  )

interface AuthorizedTeammatesRouteRouteChildren {
  AuthorizedTeammatesIndexRoute: typeof AuthorizedTeammatesIndexRoute
  AuthorizedTeammatesCreateIndexRoute: typeof AuthorizedTeammatesCreateIndexRoute
  AuthorizedTeammatesTeammateIdEditIndexRoute: typeof AuthorizedTeammatesTeammateIdEditIndexRoute
}

const AuthorizedTeammatesRouteRouteChildren: AuthorizedTeammatesRouteRouteChildren =
  {
    AuthorizedTeammatesIndexRoute: AuthorizedTeammatesIndexRoute,
    AuthorizedTeammatesCreateIndexRoute: AuthorizedTeammatesCreateIndexRoute,
    AuthorizedTeammatesTeammateIdEditIndexRoute:
      AuthorizedTeammatesTeammateIdEditIndexRoute,
  }

const AuthorizedTeammatesRouteRouteWithChildren =
  AuthorizedTeammatesRouteRoute._addFileChildren(
    AuthorizedTeammatesRouteRouteChildren,
  )

interface AuthorizedRouteRouteChildren {
  AuthorizedConsentSolutionsRouteRoute: typeof AuthorizedConsentSolutionsRouteRouteWithChildren
  AuthorizedMonthlyConsentsRouteRoute: typeof AuthorizedMonthlyConsentsRouteRouteWithChildren
  AuthorizedSubscriptionRouteRoute: typeof AuthorizedSubscriptionRouteRouteWithChildren
  AuthorizedTeammatesRouteRoute: typeof AuthorizedTeammatesRouteRouteWithChildren
  AuthorizedOnboardingRoute: typeof AuthorizedOnboardingRoute
  AuthorizedComplianceDashboardIndexRoute: typeof AuthorizedComplianceDashboardIndexRoute
  AuthorizedFreePlanIndexRoute: typeof AuthorizedFreePlanIndexRoute
  AuthorizedSubscriptionSuccessIndexRoute: typeof AuthorizedSubscriptionSuccessIndexRoute
}

const AuthorizedRouteRouteChildren: AuthorizedRouteRouteChildren = {
  AuthorizedConsentSolutionsRouteRoute:
    AuthorizedConsentSolutionsRouteRouteWithChildren,
  AuthorizedMonthlyConsentsRouteRoute:
    AuthorizedMonthlyConsentsRouteRouteWithChildren,
  AuthorizedSubscriptionRouteRoute:
    AuthorizedSubscriptionRouteRouteWithChildren,
  AuthorizedTeammatesRouteRoute: AuthorizedTeammatesRouteRouteWithChildren,
  AuthorizedOnboardingRoute: AuthorizedOnboardingRoute,
  AuthorizedComplianceDashboardIndexRoute:
    AuthorizedComplianceDashboardIndexRoute,
  AuthorizedFreePlanIndexRoute: AuthorizedFreePlanIndexRoute,
  AuthorizedSubscriptionSuccessIndexRoute:
    AuthorizedSubscriptionSuccessIndexRoute,
}

const AuthorizedRouteRouteWithChildren = AuthorizedRouteRoute._addFileChildren(
  AuthorizedRouteRouteChildren,
)

interface PublicRouteRouteChildren {
  PublicLoginIndexRoute: typeof PublicLoginIndexRoute
  PublicRecoveryEmailIndexRoute: typeof PublicRecoveryEmailIndexRoute
  PublicNewpasswordPasswordTokenCsrfTokenIndexRoute: typeof PublicNewpasswordPasswordTokenCsrfTokenIndexRoute
  PublicNotificationsUnsubscribeFailureIndexRoute: typeof PublicNotificationsUnsubscribeFailureIndexRoute
  PublicNotificationsUnsubscribeSuccessPayloadIndexRoute: typeof PublicNotificationsUnsubscribeSuccessPayloadIndexRoute
}

const PublicRouteRouteChildren: PublicRouteRouteChildren = {
  PublicLoginIndexRoute: PublicLoginIndexRoute,
  PublicRecoveryEmailIndexRoute: PublicRecoveryEmailIndexRoute,
  PublicNewpasswordPasswordTokenCsrfTokenIndexRoute:
    PublicNewpasswordPasswordTokenCsrfTokenIndexRoute,
  PublicNotificationsUnsubscribeFailureIndexRoute:
    PublicNotificationsUnsubscribeFailureIndexRoute,
  PublicNotificationsUnsubscribeSuccessPayloadIndexRoute:
    PublicNotificationsUnsubscribeSuccessPayloadIndexRoute,
}

const PublicRouteRouteWithChildren = PublicRouteRoute._addFileChildren(
  PublicRouteRouteChildren,
)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '': typeof PublicRouteRouteWithChildren
  '/consent-solutions': typeof AuthorizedConsentSolutionsRouteRouteWithChildren
  '/monthly-consents': typeof AuthorizedMonthlyConsentsRouteRouteWithChildren
  '/subscription': typeof AuthorizedSubscriptionRouteRouteWithChildren
  '/teammates': typeof AuthorizedTeammatesRouteRouteWithChildren
  '/onboarding': typeof AuthorizedOnboardingRoute
  '/consent-solutions/$csId': typeof AuthorizedConsentSolutionsCsIdRouteRouteWithChildren
  '/consent-solutions/create': typeof AuthorizedConsentSolutionsCreateRoute
  '/compliance-dashboard': typeof AuthorizedComplianceDashboardIndexRoute
  '/consent-solutions/': typeof AuthorizedConsentSolutionsIndexRoute
  '/free-plan': typeof AuthorizedFreePlanIndexRoute
  '/monthly-consents/': typeof AuthorizedMonthlyConsentsIndexRoute
  '/subscription/': typeof AuthorizedSubscriptionIndexRoute
  '/teammates/': typeof AuthorizedTeammatesIndexRoute
  '/login': typeof PublicLoginIndexRoute
  '/recovery-email': typeof PublicRecoveryEmailIndexRoute
  '/consent-solutions/$csId/cookie-management': typeof AuthorizedConsentSolutionsCsIdCookieManagementRouteRouteWithChildren
  '/consent-solutions/$csId/popup': typeof AuthorizedConsentSolutionsCsIdPopupRouteRouteWithChildren
  '/consent-solutions/$csId/': typeof AuthorizedConsentSolutionsCsIdIndexRoute
  '/subscription/billing': typeof AuthorizedSubscriptionBillingIndexRoute
  '/subscription/overview': typeof AuthorizedSubscriptionOverviewIndexRoute
  '/subscription/success': typeof AuthorizedSubscriptionSuccessIndexRoute
  '/teammates/create': typeof AuthorizedTeammatesCreateIndexRoute
  '/consent-solutions/$csId/cookie-management/': typeof AuthorizedConsentSolutionsCsIdCookieManagementIndexRoute
  '/consent-solutions/$csId/copy-and-translations': typeof AuthorizedConsentSolutionsCsIdCopyAndTranslationsIndexRoute
  '/consent-solutions/$csId/domains': typeof AuthorizedConsentSolutionsCsIdDomainsIndexRoute
  '/consent-solutions/$csId/installation': typeof AuthorizedConsentSolutionsCsIdInstallationIndexRoute
  '/consent-solutions/$csId/popup/': typeof AuthorizedConsentSolutionsCsIdPopupIndexRoute
  '/consent-solutions/$csId/settings': typeof AuthorizedConsentSolutionsCsIdSettingsIndexRoute
  '/teammates/$teammateId/edit': typeof AuthorizedTeammatesTeammateIdEditIndexRoute
  '/newpassword/$passwordToken/$csrfToken': typeof PublicNewpasswordPasswordTokenCsrfTokenIndexRoute
  '/notifications/unsubscribe/failure': typeof PublicNotificationsUnsubscribeFailureIndexRoute
  '/consent-solutions/$csId/cookie-management/$cookieId': typeof AuthorizedConsentSolutionsCsIdCookieManagementCookieIdIndexRoute
  '/consent-solutions/$csId/cookie-management/create': typeof AuthorizedConsentSolutionsCsIdCookieManagementCreateIndexRoute
  '/consent-solutions/$csId/domains/$domainId': typeof AuthorizedConsentSolutionsCsIdDomainsDomainIdIndexRoute
  '/consent-solutions/$csId/domains/create': typeof AuthorizedConsentSolutionsCsIdDomainsCreateIndexRoute
  '/consent-solutions/$csId/popup/account-templates': typeof AuthorizedConsentSolutionsCsIdPopupAccountTemplatesIndexRoute
  '/consent-solutions/$csId/popup/my-templates': typeof AuthorizedConsentSolutionsCsIdPopupMyTemplatesIndexRoute
  '/consent-solutions/$csId/popup/template-gallery': typeof AuthorizedConsentSolutionsCsIdPopupTemplateGalleryIndexRoute
  '/notifications/unsubscribe/success/$payload': typeof PublicNotificationsUnsubscribeSuccessPayloadIndexRoute
  '/consent-solutions/$csId/popup/edit-template/$templateId/$templateAction': typeof AuthorizedConsentSolutionsCsIdPopupEditTemplateTemplateIdTemplateActionIndexRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '': typeof PublicRouteRouteWithChildren
  '/onboarding': typeof AuthorizedOnboardingRoute
  '/consent-solutions/create': typeof AuthorizedConsentSolutionsCreateRoute
  '/compliance-dashboard': typeof AuthorizedComplianceDashboardIndexRoute
  '/consent-solutions': typeof AuthorizedConsentSolutionsIndexRoute
  '/free-plan': typeof AuthorizedFreePlanIndexRoute
  '/monthly-consents': typeof AuthorizedMonthlyConsentsIndexRoute
  '/subscription': typeof AuthorizedSubscriptionIndexRoute
  '/teammates': typeof AuthorizedTeammatesIndexRoute
  '/login': typeof PublicLoginIndexRoute
  '/recovery-email': typeof PublicRecoveryEmailIndexRoute
  '/consent-solutions/$csId': typeof AuthorizedConsentSolutionsCsIdIndexRoute
  '/subscription/billing': typeof AuthorizedSubscriptionBillingIndexRoute
  '/subscription/overview': typeof AuthorizedSubscriptionOverviewIndexRoute
  '/subscription/success': typeof AuthorizedSubscriptionSuccessIndexRoute
  '/teammates/create': typeof AuthorizedTeammatesCreateIndexRoute
  '/consent-solutions/$csId/cookie-management': typeof AuthorizedConsentSolutionsCsIdCookieManagementIndexRoute
  '/consent-solutions/$csId/copy-and-translations': typeof AuthorizedConsentSolutionsCsIdCopyAndTranslationsIndexRoute
  '/consent-solutions/$csId/domains': typeof AuthorizedConsentSolutionsCsIdDomainsIndexRoute
  '/consent-solutions/$csId/installation': typeof AuthorizedConsentSolutionsCsIdInstallationIndexRoute
  '/consent-solutions/$csId/popup': typeof AuthorizedConsentSolutionsCsIdPopupIndexRoute
  '/consent-solutions/$csId/settings': typeof AuthorizedConsentSolutionsCsIdSettingsIndexRoute
  '/teammates/$teammateId/edit': typeof AuthorizedTeammatesTeammateIdEditIndexRoute
  '/newpassword/$passwordToken/$csrfToken': typeof PublicNewpasswordPasswordTokenCsrfTokenIndexRoute
  '/notifications/unsubscribe/failure': typeof PublicNotificationsUnsubscribeFailureIndexRoute
  '/consent-solutions/$csId/cookie-management/$cookieId': typeof AuthorizedConsentSolutionsCsIdCookieManagementCookieIdIndexRoute
  '/consent-solutions/$csId/cookie-management/create': typeof AuthorizedConsentSolutionsCsIdCookieManagementCreateIndexRoute
  '/consent-solutions/$csId/domains/$domainId': typeof AuthorizedConsentSolutionsCsIdDomainsDomainIdIndexRoute
  '/consent-solutions/$csId/domains/create': typeof AuthorizedConsentSolutionsCsIdDomainsCreateIndexRoute
  '/consent-solutions/$csId/popup/account-templates': typeof AuthorizedConsentSolutionsCsIdPopupAccountTemplatesIndexRoute
  '/consent-solutions/$csId/popup/my-templates': typeof AuthorizedConsentSolutionsCsIdPopupMyTemplatesIndexRoute
  '/consent-solutions/$csId/popup/template-gallery': typeof AuthorizedConsentSolutionsCsIdPopupTemplateGalleryIndexRoute
  '/notifications/unsubscribe/success/$payload': typeof PublicNotificationsUnsubscribeSuccessPayloadIndexRoute
  '/consent-solutions/$csId/popup/edit-template/$templateId/$templateAction': typeof AuthorizedConsentSolutionsCsIdPopupEditTemplateTemplateIdTemplateActionIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/_authorized': typeof AuthorizedRouteRouteWithChildren
  '/_public': typeof PublicRouteRouteWithChildren
  '/_authorized/consent-solutions': typeof AuthorizedConsentSolutionsRouteRouteWithChildren
  '/_authorized/monthly-consents': typeof AuthorizedMonthlyConsentsRouteRouteWithChildren
  '/_authorized/subscription': typeof AuthorizedSubscriptionRouteRouteWithChildren
  '/_authorized/teammates': typeof AuthorizedTeammatesRouteRouteWithChildren
  '/_authorized/onboarding': typeof AuthorizedOnboardingRoute
  '/_authorized/consent-solutions/$csId': typeof AuthorizedConsentSolutionsCsIdRouteRouteWithChildren
  '/_authorized/consent-solutions/create': typeof AuthorizedConsentSolutionsCreateRoute
  '/_authorized/compliance-dashboard/': typeof AuthorizedComplianceDashboardIndexRoute
  '/_authorized/consent-solutions/': typeof AuthorizedConsentSolutionsIndexRoute
  '/_authorized/free-plan/': typeof AuthorizedFreePlanIndexRoute
  '/_authorized/monthly-consents/': typeof AuthorizedMonthlyConsentsIndexRoute
  '/_authorized/subscription/': typeof AuthorizedSubscriptionIndexRoute
  '/_authorized/teammates/': typeof AuthorizedTeammatesIndexRoute
  '/_public/login/': typeof PublicLoginIndexRoute
  '/_public/recovery-email/': typeof PublicRecoveryEmailIndexRoute
  '/_authorized/consent-solutions/$csId/cookie-management': typeof AuthorizedConsentSolutionsCsIdCookieManagementRouteRouteWithChildren
  '/_authorized/consent-solutions/$csId/popup': typeof AuthorizedConsentSolutionsCsIdPopupRouteRouteWithChildren
  '/_authorized/consent-solutions/$csId/': typeof AuthorizedConsentSolutionsCsIdIndexRoute
  '/_authorized/subscription/billing/': typeof AuthorizedSubscriptionBillingIndexRoute
  '/_authorized/subscription/overview/': typeof AuthorizedSubscriptionOverviewIndexRoute
  '/_authorized/subscription_/success/': typeof AuthorizedSubscriptionSuccessIndexRoute
  '/_authorized/teammates/create/': typeof AuthorizedTeammatesCreateIndexRoute
  '/_authorized/consent-solutions/$csId/cookie-management/': typeof AuthorizedConsentSolutionsCsIdCookieManagementIndexRoute
  '/_authorized/consent-solutions/$csId/copy-and-translations/': typeof AuthorizedConsentSolutionsCsIdCopyAndTranslationsIndexRoute
  '/_authorized/consent-solutions/$csId/domains/': typeof AuthorizedConsentSolutionsCsIdDomainsIndexRoute
  '/_authorized/consent-solutions/$csId/installation/': typeof AuthorizedConsentSolutionsCsIdInstallationIndexRoute
  '/_authorized/consent-solutions/$csId/popup/': typeof AuthorizedConsentSolutionsCsIdPopupIndexRoute
  '/_authorized/consent-solutions/$csId/settings/': typeof AuthorizedConsentSolutionsCsIdSettingsIndexRoute
  '/_authorized/teammates/$teammateId/edit/': typeof AuthorizedTeammatesTeammateIdEditIndexRoute
  '/_public/newpassword/$passwordToken/$csrfToken/': typeof PublicNewpasswordPasswordTokenCsrfTokenIndexRoute
  '/_public/notifications/unsubscribe/failure/': typeof PublicNotificationsUnsubscribeFailureIndexRoute
  '/_authorized/consent-solutions/$csId/cookie-management/$cookieId/': typeof AuthorizedConsentSolutionsCsIdCookieManagementCookieIdIndexRoute
  '/_authorized/consent-solutions/$csId/cookie-management/create/': typeof AuthorizedConsentSolutionsCsIdCookieManagementCreateIndexRoute
  '/_authorized/consent-solutions/$csId/domains/$domainId/': typeof AuthorizedConsentSolutionsCsIdDomainsDomainIdIndexRoute
  '/_authorized/consent-solutions/$csId/domains/create/': typeof AuthorizedConsentSolutionsCsIdDomainsCreateIndexRoute
  '/_authorized/consent-solutions/$csId/popup/account-templates/': typeof AuthorizedConsentSolutionsCsIdPopupAccountTemplatesIndexRoute
  '/_authorized/consent-solutions/$csId/popup/my-templates/': typeof AuthorizedConsentSolutionsCsIdPopupMyTemplatesIndexRoute
  '/_authorized/consent-solutions/$csId/popup/template-gallery/': typeof AuthorizedConsentSolutionsCsIdPopupTemplateGalleryIndexRoute
  '/_public/notifications/unsubscribe/success/$payload/': typeof PublicNotificationsUnsubscribeSuccessPayloadIndexRoute
  '/_authorized/consent-solutions/$csId/popup_/edit-template/$templateId/$templateAction/': typeof AuthorizedConsentSolutionsCsIdPopupEditTemplateTemplateIdTemplateActionIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | ''
    | '/consent-solutions'
    | '/monthly-consents'
    | '/subscription'
    | '/teammates'
    | '/onboarding'
    | '/consent-solutions/$csId'
    | '/consent-solutions/create'
    | '/compliance-dashboard'
    | '/consent-solutions/'
    | '/free-plan'
    | '/monthly-consents/'
    | '/subscription/'
    | '/teammates/'
    | '/login'
    | '/recovery-email'
    | '/consent-solutions/$csId/cookie-management'
    | '/consent-solutions/$csId/popup'
    | '/consent-solutions/$csId/'
    | '/subscription/billing'
    | '/subscription/overview'
    | '/subscription/success'
    | '/teammates/create'
    | '/consent-solutions/$csId/cookie-management/'
    | '/consent-solutions/$csId/copy-and-translations'
    | '/consent-solutions/$csId/domains'
    | '/consent-solutions/$csId/installation'
    | '/consent-solutions/$csId/popup/'
    | '/consent-solutions/$csId/settings'
    | '/teammates/$teammateId/edit'
    | '/newpassword/$passwordToken/$csrfToken'
    | '/notifications/unsubscribe/failure'
    | '/consent-solutions/$csId/cookie-management/$cookieId'
    | '/consent-solutions/$csId/cookie-management/create'
    | '/consent-solutions/$csId/domains/$domainId'
    | '/consent-solutions/$csId/domains/create'
    | '/consent-solutions/$csId/popup/account-templates'
    | '/consent-solutions/$csId/popup/my-templates'
    | '/consent-solutions/$csId/popup/template-gallery'
    | '/notifications/unsubscribe/success/$payload'
    | '/consent-solutions/$csId/popup/edit-template/$templateId/$templateAction'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | ''
    | '/onboarding'
    | '/consent-solutions/create'
    | '/compliance-dashboard'
    | '/consent-solutions'
    | '/free-plan'
    | '/monthly-consents'
    | '/subscription'
    | '/teammates'
    | '/login'
    | '/recovery-email'
    | '/consent-solutions/$csId'
    | '/subscription/billing'
    | '/subscription/overview'
    | '/subscription/success'
    | '/teammates/create'
    | '/consent-solutions/$csId/cookie-management'
    | '/consent-solutions/$csId/copy-and-translations'
    | '/consent-solutions/$csId/domains'
    | '/consent-solutions/$csId/installation'
    | '/consent-solutions/$csId/popup'
    | '/consent-solutions/$csId/settings'
    | '/teammates/$teammateId/edit'
    | '/newpassword/$passwordToken/$csrfToken'
    | '/notifications/unsubscribe/failure'
    | '/consent-solutions/$csId/cookie-management/$cookieId'
    | '/consent-solutions/$csId/cookie-management/create'
    | '/consent-solutions/$csId/domains/$domainId'
    | '/consent-solutions/$csId/domains/create'
    | '/consent-solutions/$csId/popup/account-templates'
    | '/consent-solutions/$csId/popup/my-templates'
    | '/consent-solutions/$csId/popup/template-gallery'
    | '/notifications/unsubscribe/success/$payload'
    | '/consent-solutions/$csId/popup/edit-template/$templateId/$templateAction'
  id:
    | '__root__'
    | '/'
    | '/_authorized'
    | '/_public'
    | '/_authorized/consent-solutions'
    | '/_authorized/monthly-consents'
    | '/_authorized/subscription'
    | '/_authorized/teammates'
    | '/_authorized/onboarding'
    | '/_authorized/consent-solutions/$csId'
    | '/_authorized/consent-solutions/create'
    | '/_authorized/compliance-dashboard/'
    | '/_authorized/consent-solutions/'
    | '/_authorized/free-plan/'
    | '/_authorized/monthly-consents/'
    | '/_authorized/subscription/'
    | '/_authorized/teammates/'
    | '/_public/login/'
    | '/_public/recovery-email/'
    | '/_authorized/consent-solutions/$csId/cookie-management'
    | '/_authorized/consent-solutions/$csId/popup'
    | '/_authorized/consent-solutions/$csId/'
    | '/_authorized/subscription/billing/'
    | '/_authorized/subscription/overview/'
    | '/_authorized/subscription_/success/'
    | '/_authorized/teammates/create/'
    | '/_authorized/consent-solutions/$csId/cookie-management/'
    | '/_authorized/consent-solutions/$csId/copy-and-translations/'
    | '/_authorized/consent-solutions/$csId/domains/'
    | '/_authorized/consent-solutions/$csId/installation/'
    | '/_authorized/consent-solutions/$csId/popup/'
    | '/_authorized/consent-solutions/$csId/settings/'
    | '/_authorized/teammates/$teammateId/edit/'
    | '/_public/newpassword/$passwordToken/$csrfToken/'
    | '/_public/notifications/unsubscribe/failure/'
    | '/_authorized/consent-solutions/$csId/cookie-management/$cookieId/'
    | '/_authorized/consent-solutions/$csId/cookie-management/create/'
    | '/_authorized/consent-solutions/$csId/domains/$domainId/'
    | '/_authorized/consent-solutions/$csId/domains/create/'
    | '/_authorized/consent-solutions/$csId/popup/account-templates/'
    | '/_authorized/consent-solutions/$csId/popup/my-templates/'
    | '/_authorized/consent-solutions/$csId/popup/template-gallery/'
    | '/_public/notifications/unsubscribe/success/$payload/'
    | '/_authorized/consent-solutions/$csId/popup_/edit-template/$templateId/$templateAction/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthorizedRouteRoute: typeof AuthorizedRouteRouteWithChildren
  PublicRouteRoute: typeof PublicRouteRouteWithChildren
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthorizedRouteRoute: AuthorizedRouteRouteWithChildren,
  PublicRouteRoute: PublicRouteRouteWithChildren,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_authorized",
        "/_public"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_authorized": {
      "filePath": "_authorized/route.tsx",
      "children": [
        "/_authorized/consent-solutions",
        "/_authorized/monthly-consents",
        "/_authorized/subscription",
        "/_authorized/teammates",
        "/_authorized/onboarding",
        "/_authorized/compliance-dashboard/",
        "/_authorized/free-plan/",
        "/_authorized/subscription_/success/"
      ]
    },
    "/_public": {
      "filePath": "_public/route.tsx",
      "children": [
        "/_public/login/",
        "/_public/recovery-email/",
        "/_public/newpassword/$passwordToken/$csrfToken/",
        "/_public/notifications/unsubscribe/failure/",
        "/_public/notifications/unsubscribe/success/$payload/"
      ]
    },
    "/_authorized/consent-solutions": {
      "filePath": "_authorized/consent-solutions/route.tsx",
      "parent": "/_authorized",
      "children": [
        "/_authorized/consent-solutions/$csId",
        "/_authorized/consent-solutions/create",
        "/_authorized/consent-solutions/"
      ]
    },
    "/_authorized/monthly-consents": {
      "filePath": "_authorized/monthly-consents/route.tsx",
      "parent": "/_authorized",
      "children": [
        "/_authorized/monthly-consents/"
      ]
    },
    "/_authorized/subscription": {
      "filePath": "_authorized/subscription/route.tsx",
      "parent": "/_authorized",
      "children": [
        "/_authorized/subscription/",
        "/_authorized/subscription/billing/",
        "/_authorized/subscription/overview/"
      ]
    },
    "/_authorized/teammates": {
      "filePath": "_authorized/teammates/route.tsx",
      "parent": "/_authorized",
      "children": [
        "/_authorized/teammates/",
        "/_authorized/teammates/create/",
        "/_authorized/teammates/$teammateId/edit/"
      ]
    },
    "/_authorized/onboarding": {
      "filePath": "_authorized/onboarding.tsx",
      "parent": "/_authorized"
    },
    "/_authorized/consent-solutions/$csId": {
      "filePath": "_authorized/consent-solutions/$csId/route.tsx",
      "parent": "/_authorized/consent-solutions",
      "children": [
        "/_authorized/consent-solutions/$csId/cookie-management",
        "/_authorized/consent-solutions/$csId/popup",
        "/_authorized/consent-solutions/$csId/",
        "/_authorized/consent-solutions/$csId/copy-and-translations/",
        "/_authorized/consent-solutions/$csId/domains/",
        "/_authorized/consent-solutions/$csId/installation/",
        "/_authorized/consent-solutions/$csId/settings/",
        "/_authorized/consent-solutions/$csId/domains/$domainId/",
        "/_authorized/consent-solutions/$csId/domains/create/",
        "/_authorized/consent-solutions/$csId/popup_/edit-template/$templateId/$templateAction/"
      ]
    },
    "/_authorized/consent-solutions/create": {
      "filePath": "_authorized/consent-solutions/create.tsx",
      "parent": "/_authorized/consent-solutions"
    },
    "/_authorized/compliance-dashboard/": {
      "filePath": "_authorized/compliance-dashboard/index.tsx",
      "parent": "/_authorized"
    },
    "/_authorized/consent-solutions/": {
      "filePath": "_authorized/consent-solutions/index.tsx",
      "parent": "/_authorized/consent-solutions"
    },
    "/_authorized/free-plan/": {
      "filePath": "_authorized/free-plan/index.tsx",
      "parent": "/_authorized"
    },
    "/_authorized/monthly-consents/": {
      "filePath": "_authorized/monthly-consents/index.tsx",
      "parent": "/_authorized/monthly-consents"
    },
    "/_authorized/subscription/": {
      "filePath": "_authorized/subscription/index.tsx",
      "parent": "/_authorized/subscription"
    },
    "/_authorized/teammates/": {
      "filePath": "_authorized/teammates/index.tsx",
      "parent": "/_authorized/teammates"
    },
    "/_public/login/": {
      "filePath": "_public/login/index.tsx",
      "parent": "/_public"
    },
    "/_public/recovery-email/": {
      "filePath": "_public/recovery-email/index.tsx",
      "parent": "/_public"
    },
    "/_authorized/consent-solutions/$csId/cookie-management": {
      "filePath": "_authorized/consent-solutions/$csId/cookie-management/route.tsx",
      "parent": "/_authorized/consent-solutions/$csId",
      "children": [
        "/_authorized/consent-solutions/$csId/cookie-management/",
        "/_authorized/consent-solutions/$csId/cookie-management/$cookieId/",
        "/_authorized/consent-solutions/$csId/cookie-management/create/"
      ]
    },
    "/_authorized/consent-solutions/$csId/popup": {
      "filePath": "_authorized/consent-solutions/$csId/popup/route.tsx",
      "parent": "/_authorized/consent-solutions/$csId",
      "children": [
        "/_authorized/consent-solutions/$csId/popup/",
        "/_authorized/consent-solutions/$csId/popup/account-templates/",
        "/_authorized/consent-solutions/$csId/popup/my-templates/",
        "/_authorized/consent-solutions/$csId/popup/template-gallery/"
      ]
    },
    "/_authorized/consent-solutions/$csId/": {
      "filePath": "_authorized/consent-solutions/$csId/index.tsx",
      "parent": "/_authorized/consent-solutions/$csId"
    },
    "/_authorized/subscription/billing/": {
      "filePath": "_authorized/subscription/billing/index.tsx",
      "parent": "/_authorized/subscription"
    },
    "/_authorized/subscription/overview/": {
      "filePath": "_authorized/subscription/overview/index.tsx",
      "parent": "/_authorized/subscription"
    },
    "/_authorized/subscription_/success/": {
      "filePath": "_authorized/subscription_.success/index.tsx",
      "parent": "/_authorized"
    },
    "/_authorized/teammates/create/": {
      "filePath": "_authorized/teammates/create/index.tsx",
      "parent": "/_authorized/teammates"
    },
    "/_authorized/consent-solutions/$csId/cookie-management/": {
      "filePath": "_authorized/consent-solutions/$csId/cookie-management/index.tsx",
      "parent": "/_authorized/consent-solutions/$csId/cookie-management"
    },
    "/_authorized/consent-solutions/$csId/copy-and-translations/": {
      "filePath": "_authorized/consent-solutions/$csId/copy-and-translations/index.tsx",
      "parent": "/_authorized/consent-solutions/$csId"
    },
    "/_authorized/consent-solutions/$csId/domains/": {
      "filePath": "_authorized/consent-solutions/$csId/domains/index.tsx",
      "parent": "/_authorized/consent-solutions/$csId"
    },
    "/_authorized/consent-solutions/$csId/installation/": {
      "filePath": "_authorized/consent-solutions/$csId/installation/index.tsx",
      "parent": "/_authorized/consent-solutions/$csId"
    },
    "/_authorized/consent-solutions/$csId/popup/": {
      "filePath": "_authorized/consent-solutions/$csId/popup/index.tsx",
      "parent": "/_authorized/consent-solutions/$csId/popup"
    },
    "/_authorized/consent-solutions/$csId/settings/": {
      "filePath": "_authorized/consent-solutions/$csId/settings/index.tsx",
      "parent": "/_authorized/consent-solutions/$csId"
    },
    "/_authorized/teammates/$teammateId/edit/": {
      "filePath": "_authorized/teammates/$teammateId/edit/index.tsx",
      "parent": "/_authorized/teammates"
    },
    "/_public/newpassword/$passwordToken/$csrfToken/": {
      "filePath": "_public/newpassword/$passwordToken/$csrfToken/index.tsx",
      "parent": "/_public"
    },
    "/_public/notifications/unsubscribe/failure/": {
      "filePath": "_public/notifications/unsubscribe/failure/index.tsx",
      "parent": "/_public"
    },
    "/_authorized/consent-solutions/$csId/cookie-management/$cookieId/": {
      "filePath": "_authorized/consent-solutions/$csId/cookie-management/$cookieId/index.tsx",
      "parent": "/_authorized/consent-solutions/$csId/cookie-management"
    },
    "/_authorized/consent-solutions/$csId/cookie-management/create/": {
      "filePath": "_authorized/consent-solutions/$csId/cookie-management/create/index.tsx",
      "parent": "/_authorized/consent-solutions/$csId/cookie-management"
    },
    "/_authorized/consent-solutions/$csId/domains/$domainId/": {
      "filePath": "_authorized/consent-solutions/$csId/domains/$domainId/index.tsx",
      "parent": "/_authorized/consent-solutions/$csId"
    },
    "/_authorized/consent-solutions/$csId/domains/create/": {
      "filePath": "_authorized/consent-solutions/$csId/domains/create/index.tsx",
      "parent": "/_authorized/consent-solutions/$csId"
    },
    "/_authorized/consent-solutions/$csId/popup/account-templates/": {
      "filePath": "_authorized/consent-solutions/$csId/popup/account-templates/index.tsx",
      "parent": "/_authorized/consent-solutions/$csId/popup"
    },
    "/_authorized/consent-solutions/$csId/popup/my-templates/": {
      "filePath": "_authorized/consent-solutions/$csId/popup/my-templates/index.tsx",
      "parent": "/_authorized/consent-solutions/$csId/popup"
    },
    "/_authorized/consent-solutions/$csId/popup/template-gallery/": {
      "filePath": "_authorized/consent-solutions/$csId/popup/template-gallery/index.tsx",
      "parent": "/_authorized/consent-solutions/$csId/popup"
    },
    "/_public/notifications/unsubscribe/success/$payload/": {
      "filePath": "_public/notifications/unsubscribe/success/$payload/index.tsx",
      "parent": "/_public"
    },
    "/_authorized/consent-solutions/$csId/popup_/edit-template/$templateId/$templateAction/": {
      "filePath": "_authorized/consent-solutions/$csId/popup_.edit-template/$templateId/$templateAction/index.tsx",
      "parent": "/_authorized/consent-solutions/$csId"
    }
  }
}
ROUTE_MANIFEST_END */
